export const PIPELINE_STAGE_LABELS = {
  prospect: "Prospecto",
  contacted: "Contactado",
  interested: "Interesado",
  demo_scheduled: "Demo agendada",
  onboarding_started: "Onboarding iniciado",
  inventory_received: "Inventario recibido",
  inventory_cleaning: "Limpieza inventario",
  verification_pending: "Verificación pendiente",
  launch_ready: "Listo para lanzar",
  active: "Activo",
  not_interested: "No interesado",
  blocked: "Bloqueado",
};

export const READINESS_LABELS = {
  not_started: "Sin iniciar",
  in_progress: "En progreso",
  needs_inventory: "Necesita inventario",
  needs_verification: "Necesita verificación",
  needs_cleanup: "Necesita limpieza",
  launch_ready: "Listo para lanzar",
  active: "Activo",
};

export const FOUNDING_COHORT_TARGETS = {
  minLaunchReadyDealers: 10,
  targetLaunchReadyDealers: 20,
  minCleanListings: 500,
  targetCleanListings: 1500,
};

export function trackFoundingDealerEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[founding-dealer-event]", eventType, metadata);
  }
}

export function whatsappUrl(phone, message) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message || "")}`;
}
